import * as React from 'react';
import { SVGProps, memo } from 'react';

function CalendarIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
      <g stroke="#333" strokeLinecap="round">
        <path d="M8 3.03v3M16 3.03v3" />
        <path d="M20.5 20.03a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h15v15Z" clipRule="evenodd" />
        <path d="M20.5 8.065h-17" />
        <g strokeLinejoin="round">
          <path d="M8.809 14.436a2.75 2.75 0 0 1 .514-.047c1.3 0 2.356.904 2.356 2.018 0 1.116-1.054 2.154-2.357 2.154a2.201 2.201 0 0 1-1.947-1.076M7.371 11.83h4.038L8.8 14.437M14.101 12.908l2.154-1.347v7" />
        </g>
      </g>
    </svg>
  );
}

export function DatePickerCalendarIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M10.6663 3.37335V7.37335" stroke="black" strokeLinecap="round" />
      <path d="M21.3333 3.37335V7.37335" stroke="black" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3337 26.04C27.3337 27.5128 26.1398 28.7067 24.667 28.7067H7.33366C5.8609 28.7067 4.66699 27.5128 4.66699 26.04V8.70671C4.66699 7.23395 5.8609 6.04004 7.33366 6.04004H27.3337V26.04Z"
        stroke="black"
        strokeLinecap="round"
      />
      <path d="M27.3337 10.0866H4.66699" stroke="black" strokeLinecap="round" />
      <path
        d="M11.7447 18.5817C11.9705 18.5393 12.1999 18.5181 12.4297 18.5184C14.1647 18.5184 15.5713 19.7234 15.5713 21.21C15.5713 22.6967 14.1663 24.0817 12.4297 24.0817C11.3683 24.1083 10.3753 23.5595 9.83301 22.6467"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.82812 15.1067H15.2115L11.7348 18.5834" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.8018 16.5434L21.6734 14.7484V24.0817" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
export default memo(CalendarIcon);
